export default __webpack_public_path__ + "static/hypershift-ed36eca945721a01def8a5db7b442a77.svg";